<template>
  <el-container class="chat-page">
    <resizable-aside v-show="configStore.menuVisible" :default-width="260" :min-width="200" :max-width="500" storage-key="chat-aside-width">
      <div class="header" :class="configStore.electronMode ? 'header-menu-wrap' : ''">
        <el-input class="search-text" size="small" :placeholder="$t('common.search')" v-model="searchText">
          <i class="el-icon-search el-input__icon" slot="prefix"> </i>
        </el-input>
      </div>
      <div class="chat-loading" v-if="initializing" v-loading="true" :element-loading-text="$t('chat.initializing')"
        element-loading-spinner="el-icon-loading" element-loading-background="#F9F9F9" element-loading-size="24">
      </div>
      <div class="chat-loading" v-else-if="loading" v-loading="true" :element-loading-text="$t('chat.receivingMsg')"
        element-loading-spinner="el-icon-loading" element-loading-background="#F9F9F9" element-loading-size="24">
      </div>
      <virtual-scroller class="scroll-box" :items="showChats">
        <template v-slot="{ item }">
          <chat-item :chat="item" @click.native="onActiveItem(item)" @delete="onDelItem(item)" @info="onShowInfo(item)"
            @dnd="onDnd(item)" @top="onTop(item)" @remark="onModifyRemarks(item)" :active="item === chatStore.activeChat"></chat-item>
        </template>
      </virtual-scroller>
    </resizable-aside>
    <el-container class="chat-box">
      <chat-box v-if="activeChat && activeChat.type != 'SYSTEM'" :chat="activeChat" @messageEdited="onMessageEdited"></chat-box>
      <chat-system-box v-if="activeChat && activeChat.type == 'SYSTEM'" :chat="activeChat"></chat-system-box>
      <div v-if="!activeChat" class="welcome-box">
        <img src="@/assets/image/fav.png" class="welcome-logo" />
        <h2 class="welcome-title">{{ $t('chat.welcomeTitle', { name: 'The Social Club of Desire' }) }}</h2>
        <p class="welcome-desc">{{ $t('chat.welcomeDesc') }}</p>
      </div>
    </el-container>

		<el-dialog
			:title="$t('friend.modifyRemark')"
			:visible.sync="editDialogVisible"
			width="30%"
			:before-close="handleCloseEdit">
			<div>
				<el-input
					type="textarea"
					:rows="4"
					:placeholder="$t('common.inputContent')"
					v-model="editContent">
				</el-input>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="editDialogVisible = false">{{ $t('common.cancel') }}</el-button>
				<el-button type="primary" @click="handleConfirmEdit">{{ $t('common.confirm') }}</el-button>
			</span>
		</el-dialog>
  </el-container>
</template>

<script>
import ChatItem from "../components/chat/ChatItem.vue";
import ChatBox from "../components/chat/ChatBox.vue";
import ChatSystemBox from "../components/chat/ChatSystemBox.vue";
import ResizableAside from "../components/common/ResizableAside.vue";
import VirtualScroller from "../components/common/VirtualScroller.vue";
export default {
  name: "chat",
  components: {
    ChatItem,
    ChatBox,
    ChatSystemBox,
    ResizableAside,
    VirtualScroller
  },
  data() {
    return {
      searchText: "",
      messageContent: "",
      isChat: {},
      group: {},
      groupMembers: [],
      editDialogVisible: false,
      editContent: ''
    }
  },
  methods: {
    onActiveItem(chat) {
      this.chatStore.setActiveChat(chat);
    },
    onDelItem(chat) {
      this.$confirm(this.$t('chat.deleteChat', { name: chat.showName }), this.$t('chat.deleteChatTitle'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(async () => {
        if (chat.type == 'PRIVATE' || chat.type == 'GROUP') {
          const data = {
            chatId: chat.targetId
          }
          await this.$http({
            url: `/message/${chat.type.toLowerCase()}/deleteChat`,
            method: 'delete',
            data: data
          });
        }
        this.chatStore.removeChat(chat);
      });
    },
    onShowInfo(chat) {
      if (chat.type == 'PRIVATE') {
        this.$router.push("/home/friend?id=" + chat.targetId);
      } else if (chat.type == 'GROUP') {
        if (!this.groupStore.isGroup(chat.targetId)) {
          this.$message.error(this.$t('chat.notInGroup'))
          return;
        }
        this.$router.push("/home/group?id=" + chat.targetId);
      }
    },
    handleCloseEdit(){
      this.editDialogVisible = false;
    },
    handleConfirmEdit() {
            const newRemark = this.editContent.trim();
            // 参考Friend.vue的API调用逻辑
            let data = {
                friendId: this.isChat.targetId,
                remarkNickName: newRemark
            };
            this.$http({
                url: '/friend/update/remark',
                method: 'PUT',
                data: data
            }).then((friend) => {
                // 更新本地数据，参考Friend.vue的更新逻辑
                this.friendStore.updateFriend(friend);
                this.chatStore.updateChatFromFriend(friend);
                // 显示成功消息
                this.$message.success(newRemark ? this.$t('chat.remarkSuccess') : this.$t('chat.remarkCleared'));
            }).finally(() => {
                // 退出编辑模式
                this.editDialogVisible = false;
            });
    },
    onModifyRemarks(chat) {
      this.editContent = chat.showName || '';
      this.editDialogVisible = true;
      this.isChat = chat;
      console.log(chat)
    },
    onDnd(chat) {
      if (chat.type == 'PRIVATE') {
        this.setFriendDnd(chat, chat.targetId, !chat.isDnd)
      } else {
        this.setGroupDnd(chat, chat.targetId, !chat.isDnd)
      }
    },
    setFriendDnd(chat, friendId, isDnd) {
      let formData = {
        friendId: friendId,
        isDnd: isDnd
      }
      this.$http({
        url: '/friend/dnd',
        method: 'put',
        data: formData
      }).then(() => {
        this.friendStore.setDnd(friendId, isDnd)
        this.chatStore.setDnd(chat, isDnd)
      })
    },
    setGroupDnd(chat, groupId, isDnd) {
      let formData = {
        groupId: groupId,
        isDnd: isDnd
      }
      this.$http({
        url: '/group/dnd',
        method: 'put',
        data: formData
      }).then(() => {
        this.groupStore.setDnd(groupId, isDnd)
        this.chatStore.setDnd(chat, isDnd)
      })
    },
    onTop(chat) {
      if (chat.type == 'PRIVATE') {
        this.setFriendTop(chat, chat.targetId, !chat.isTop)
      } else {
        this.setGroupTop(chat, chat.targetId, !chat.isTop)
      }
    },
    setFriendTop(chat, friendId, isTop) {
      let formData = {
        friendId: friendId,
        isTop: isTop
      }
      this.$http({
        url: '/friend/top',
        method: 'put',
        data: formData
      }).then(() => {
        this.friendStore.setTop(friendId, isTop)
        this.chatStore.setTop(chat, isTop)
      })
    },
    setGroupTop(chat, groupId, isTop) {
      let formData = {
        groupId: groupId,
        isTop: isTop
      }
      this.$http({
        url: '/group/top',
        method: 'put',
        data: formData
      }).then(() => {
        this.groupStore.setTop(groupId, isTop)
        this.chatStore.setTop(chat, isTop)
      })
    },
    isShowChat(chat) {
      return !this.searchText || chat.showName.includes(this.searchText)
    },
    onMessageEdited(msgInfo,msgItem){
    }
  },
  computed: {
    activeChat() {
      return this.chatStore.activeChat;
    },
    loading() {
      return this.chatStore.loading
    },
    initializing() {
      return !this.configStore.appInit;
    },
    showChats() {
      console.log(this.chatStore.chats)
      return this.chatStore.chats.filter(chat => this.isShowChat(chat));
    }
  }
}
</script>

<style lang="scss">
.chat-page {
  .header {
    height: 60px;
    display: flex;
    align-items: center;
    padding: 0 12px;
  }

  .chat-loading {
    height: 50px;
    background-color: #eee;

    .el-icon-loading {
      font-size: 24px;
      color: var(--im-text-color-light);
    }

    .el-loading-text {
      color: var(--im-text-color-light);
    }

    .chat-loading-box {
      height: 100%;
    }
  }

  .chat-items {
    flex: 1;
  }

  .welcome-box {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #f8f9fa;
    text-align: center;

    .welcome-logo {
      width: 120px;
      height: 120px;
      margin-bottom: 24px;
      filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.1));
    }

    .welcome-title {
      font-size: 28px;
      color: var(--im-text-color-primary);
      margin-bottom: 12px;
      font-weight: 600;
    }

    .welcome-desc {
      font-size: 16px;
      color: var(--im-text-color-light);
      max-width: 400px;
      line-height: 1.6;
    }
  }
}
</style>
